const CLOUDFRONT_BASE = process.env.REACT_APP_CLOUDFRONT_URL || "";

export const getAuditPlanFileUrl = (path) => {
  if (!path) return null;
  return `${CLOUDFRONT_BASE}/${path}`;
};

export const getAuditPlanViewerUrl = (path) => {
  const fileUrl = getAuditPlanFileUrl(path);
  if (!fileUrl) return null;
  const lower = path.toLowerCase();
  if (lower.endsWith(".docx")) {
    return fileUrl.replace(/\.docx$/i, ".pdf");
  }
  return fileUrl;
};

export const AUDIT_PLAN_ALLOWED_TYPES = [".pdf", ".docx"];

export const downloadAuditPlanFile = async (file) => {
  const fileUrl = getAuditPlanFileUrl(file?.path);
  if (!fileUrl) return;
  try {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = file.maskName || "audit-plan";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Error downloading audit plan:", error);
    window.open(fileUrl, "_blank");
  }
};

export const isAuditPlanPdfViewable = (path) => {
  const lower = (path || "").toLowerCase();
  return lower.endsWith(".pdf") || lower.endsWith(".docx");
};
